import type { ReactNode } from "react";
import { Component } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

type DrilldownChartErrorBoundaryProps = {
  children: ReactNode;
};

type DrilldownChartErrorBoundaryState = {
  hasError: boolean;
};

export class DrilldownChartErrorBoundary extends Component<
  DrilldownChartErrorBoundaryProps,
  DrilldownChartErrorBoundaryState
> {
  state: DrilldownChartErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): DrilldownChartErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert variant="destructive" className="m-4">
          <AlertTitle>Something went wrong</AlertTitle>
          <AlertDescription>
            We couldn&apos;t render this chart. Try switching back to the table
            view or refreshing the page.
          </AlertDescription>
        </Alert>
      );
    }

    return this.props.children;
  }
}
